import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "../../ui/Modal";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as patientRegisterActions from "../../../actions/patientRegisterActions";
import bindActions from "../../../helpers/bindActions";
import Show from "../../widgets/Show";
import { withRouter } from "react-router";
import { Routes } from "../../../constants/Routes";
import { SelectPicker } from "../../select-picker/SelectPicker";
import SignerComponent from "../../SignerComponent";
import * as simpleModalActions from "../../../actions/simpleModalActions";
import {
  AutoKeyAddANSIData,
  ClearTablet,
  GetSigImageB64,
  IsSigWebInstalled,
  NumberOfTabletPoints,
  SetDisplayXSize,
  SetDisplayYSize,
  SetEncryptionMode,
  SetImagePenWidth,
  SetImageXSize,
  SetImageYSize,
  SetJustifyMode,
  SetKeyString,
  SetSigCompressionMode,
  SetTabletState,
} from "../../../SigWebTablet";

let tmr;
let interval;

const enhancer = connect(
  ({ patientRegister }) => ({ patientRegister }),
  bindActions({ patientRegisterActions, simpleModalActions }),
);
class PrintModal extends PureComponent {
  static propTypes = {
    patientRegister: PropTypes.object,
    claimsDocTypeList: PropTypes.array,
    patientRegisterActions: PropTypes.object,
    claimRequestTypeCode: PropTypes.string,
    selectedItemId: PropTypes.number,
    setModalVisible: PropTypes.func,
    view: PropTypes.bool,
    item: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      docType: "",
      mouseDown: false,
      activeTab: "1",
      signatureTimer: 0,
      isSigWebInstalled: false,
    };
  }

  componentWillUnmount() {
    this.setState({ signatureTimer: 0 });
    clearInterval(interval);
    if (this.state.isSigWebInstalled) {
      SetTabletState(0, tmr);
    }
  }

  componentDidUpdate() {
    if (this.canvas) {
      this.context = this.canvas.getContext("2d");
      this.context.lineWidth = 1;
      this.context.strokeStyle = "#000";
      this.context.lineJoin = this.context.lineCap = "round";

      this.bb = this.canvas.getBoundingClientRect();

      const img = new Image();
      img.onload = () => {
        this.context.drawImage(img, 0, 0);
      };
      img.src = this.props.patientRegister.signature;
    }
  }

  mouseDown = (e) => {
    if (!this.state.mouseDown) this.setState({ mouseDown: true });

    this.context.moveTo(
      (e.clientX || e.touches[0].clientX) - this.bb.left,
      (e.clientY || e.touches[0].clientY) - this.bb.top,
    );
  };

  mouseUp = () => {
    this.setState({ mouseDown: false });
  };

  mouseMove = (e) => {
    if (this.state.mouseDown) {
      // prevent IOS scroll when drawing
      if (e.touches) e.preventDefault();

      if (
        (e.clientX || e.touches[0].clientX) > 0 &&
        (e.clientY || e.touches[0].clientY) - this.bb.top < 200
      ) {
        this.context.lineTo(
          (e.clientX || e.touches[0].clientX) - this.bb.left,
          (e.clientY || e.touches[0].clientY) - this.bb.top,
        );

        this.context.stroke();
      }
    }
  };

  clearCanvas = () => {
    if (this.context && this.canvas) {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.beginPath();
    }
  };

  done = () => {
    const isEmpty = (ctx) => {
      const data = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height).data;
      return !Array.prototype.some.call(data, function (p) {
        return p > 0;
      });
    };
    const empty = isEmpty(this.context);
    if (typeof this.props.addSignature === "function") {
      if (empty) {
        return this.props.simpleModalActions.openSimpleModal({ body: "please sign" });
      }
      this.props.addSignature(this.canvas.toDataURL());
    } else {
      if (empty) {
        return this.props.simpleModalActions.openSimpleModal({ body: "please sign" });
      }
      this.props.patientRegisterActions.addSignature(this.canvas.toDataURL());
    }

    if (typeof this.props.closeSignature === "function") {
      this.props.closeSignature();
    } else {
      this.props.patientRegisterActions.closeSignature();
    }
  };

  handleSelectDocType = (docType) => {
    this.setState({ docType });
  };

  handleSignerDone = () => {
      if (Number(NumberOfTabletPoints()) === 0) {
        this.props.simpleModalActions.openSimpleModal({ body: "Please sign before continuing" });
      } else {
        SetTabletState(0, tmr);
        let CryptoData = "";
        CryptoData = "This represents sample data the signer reads and is agreeing to when signing.";
        CryptoData = CryptoData + "Concatenate all this data into a single variable.";
        AutoKeyAddANSIData(CryptoData);
        SetEncryptionMode(2);
        SetSigCompressionMode(1);
        SetImageXSize(500);
        SetImageYSize(100);
        SetImagePenWidth(5);
        GetSigImageB64(this.handleSaveSignerImage);
        typeof this.props.closeSignature === "function"
          ? this.props.closeSignature()
          : this.props.patientRegisterActions.closeSignature();
      }
    };

   handleSaveSignerImage = (image) => {
      this.props.patientRegisterActions.addSignature(`data:image/png;base64,${image}`);
    };

  setTimer = () => {
    interval = setInterval(() => {
      this.setState({ signatureTimer: this.state.signatureTimer + 1 });
    }, 1000);
  };

  setActiveTab = (activeTab) => {
    this.setState({ activeTab });
    if (activeTab === "1") {
      this.setState({ signatureTimer: 0 });
      clearInterval(interval);
      if (this.state.isSigWebInstalled) {
        SetTabletState(0, tmr);
      }
    }
    if (activeTab === "2") {
      this.setState({ isSigWebInstalled: IsSigWebInstalled() });
    }
  };

  handleSignatureStart = () => {
    if (this.state.isSigWebInstalled) {
      this.setTimer();
      ClearTablet();
      const ctx = document.getElementById("cnv").getContext("2d");
      SetDisplayXSize(500);
      SetDisplayYSize(100);
      SetTabletState(0, tmr);
      SetJustifyMode(0);
      ClearTablet();
      SetKeyString("0000000000000000");
      SetEncryptionMode(0);
      if (tmr == null) {
        tmr = SetTabletState(1, ctx, 50);
      } else {
        SetTabletState(0, tmr);
        tmr = null;
        tmr = SetTabletState(1, ctx, 50);
      }
    } else {
      this.props.simpleModalActions.openSimpleModal({
        body:
          "Unable to communicate with SigWeb. Please confirm that SigWeb is installed and running on this PC.",
      });
    }
  };

  handleSubmit = () => {
    const {
      claimRequestTypeCode,
      selectedItemId,
      setModalVisible,
      patientRegisterActions,
    } = this.props;
    const data = {
      id: selectedItemId,
      claimRequestTypeCode,
      documentTypeCode: this.state.docType,
    };
    patientRegisterActions.printClaim(data).then((response) => {
      if (response) {
        patientRegisterActions.savePdf(response);
        this.props.history.push(Routes.PatientClaimsApprovalsPdfView);
      }
    });
    setModalVisible();
    this.clearFields();
  };

  clearFields = () => {
    this.props.patientRegisterActions.addSignature("");
    this.setState({ docType: "" });
  };

  render() {
    const {
      props: {
        setModalVisible,
        show,
        view,
        claimsDocTypeList,
        patientRegister: { signature },
      },
      state: { docType },
    } = this;
    const options = claimsDocTypeList.length
      ? claimsDocTypeList.map((status) => {
          return { label: status.name, value: status.code };
        })
      : [];
    const readyToSubmit = (view || (signature && signature.length !== 0)) && docType;

    if (60 - this.state.signatureTimer === 0) {
      this.setState({ signatureTimer: 0 });
      clearInterval(interval);
      if (this.state.isSigWebInstalled) {
        SetTabletState(0, tmr);
      }
    }

    return (
      <Modal
        show={show}
        size="xs"
        animation={false}
        onHide={setModalVisible}
        title={<div>Please select pdf template and sign</div>}
        actions={
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                if (this.state.isSigWebInstalled) {
                  ClearTablet();
                  SetTabletState(0, tmr);
                }

                setModalVisible();
                this.clearFields();
              }}
            >
              Cancel
            </button>
            <button
              disabled={!readyToSubmit}
              type="button"
              className="btn btn-primary"
              onClick={this.handleSubmit}
            >
              {view ? "View" : "Print"}
            </button>
          </div>
        }
      >
        <div className="d-flex flex-column align-items-center">
          <div style={{ width: "100%" }}>
            <div>PDF template:</div>
            <div
              className="form-group"
              style={{
                width: "100%",
                lineHeight: "30px",
                textAlign: "initial",
              }}
            >
              <SelectPicker
                placeholder="choose template"
                options={options}
                value={{ value: docType }}
                onChange={(x) => this.handleSelectDocType(x.value)}
              />
            </div>
            <Show if={!view && !signature.length}>
              <div className="d-flex flex-column align-items-center">
                <h4>Please sign below:</h4>
                <div className="btn-group w-100">
                  <div
                    style={{ width: `50%` }}
                    className={`btn ${
                      this.state.activeTab === "1" ? "btn-success" : "btn-default"
                    }`}
                    onClick={() => this.setActiveTab("1")}
                  >
                    Manual Signature
                  </div>
                  <div
                    style={{ width: `50%` }}
                    className={`btn ${
                      this.state.activeTab === "2" ? "btn-success" : "btn-default"
                    }`}
                    onClick={() => this.setActiveTab("2")}
                  >
                    Signature Pad
                  </div>
                </div>
                <Show if={this.state.activeTab === "1"}>
                  <div
                    style={{
                      border: "1px solid rgb(229, 229, 229)",
                      marginTop: "20px",
                      borderRadius: "5px",
                    }}
                  >
                    <canvas
                      ref={(c) => (this.canvas = c)}
                      width={570}
                      height={350}
                      onMouseDown={this.mouseDown}
                      onTouchStart={this.mouseDown}
                      onMouseUp={this.mouseUp}
                      onTouchEnd={this.mouseUp}
                      onMouseMove={this.mouseMove}
                      onTouchMove={this.mouseMove}
                    />
                  </div>
                </Show>
                <Show if={this.state.activeTab === "2"}>
                  <div
                    style={{
                      border: "1px solid rgb(229, 229, 229)",
                      marginTop: "20px",
                      borderRadius: "5px",
                    }}
                  >
                    <SignerComponent
                      ref={(e) => (this.canvas = e)}
                      handleSignerStart={this.handleSignatureStart}
                    />
                  </div>
                </Show>
                <Show if={this.state.activeTab === "1"}>
                  <div
                    className="mt-3 d-flex justify-content-end"
                    style={{ width: "100%", gap: "5px" }}
                  >
                    <Button onClick={this.clearCanvas}>Re-try</Button>
                    <Button bsStyle="primary" onClick={this.done}>
                      Done
                    </Button>
                  </div>
                </Show>
                <Show if={this.state.activeTab === "2"}>
                  <div
                    className="mt-3 d-flex justify-content-end"
                    style={{ width: "100%", gap: "5px" }}
                  >
                    <Button
                      disabled={this.state.signatureTimer !== 0}
                      onClick={this.handleSignerStart}
                    >
                      {this.state.signatureTimer !== 0 ? (
                        <span>
                          00:
                          {this.state.signatureTimer === 0
                            ? "00"
                            : this.state.signatureTimer > 50
                            ? "0" + (60 - this.state.signatureTimer)
                            : 60 - this.state.signatureTimer}
                        </span>
                      ) : (
                        "Re-try"
                      )}
                    </Button>
                    <Button
                      onClick={() => {
                        if (this.state.isSigWebInstalled) {
                          ClearTablet();
                        }
                        if (this.context && this.canvas) {
                          this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                          this.context.beginPath();
                        }
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      disabled={!this.state.isSigWebInstalled}
                      onClick={this.handleSignerDone}
                    >
                      Done
                    </Button>
                  </div>
                </Show>
              </div>
            </Show>
            <Show if={!view && signature.length}>
              <img src={signature} alt="signature" />
            </Show>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(enhancer(PrintModal));
